const DIRECTORY_DELETE_ROLES = new Set(['admin', 'owner', 'superadmin']);

export function canDeleteDirectoryEntity(role?: string | null): boolean {
  return DIRECTORY_DELETE_ROLES.has((role || '').trim().toLowerCase());
}
